import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Overlay, ProductTile, TextSize } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { findColor } from '@as-react/common-utils';
import { HeartFillIcon, HeartIcon } from '@yonderland/andes-icons';
import { Checkbox, IconButton, Stack, TextAlpha } from '@yonderland/andes-react';
import { Price } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { ProductImageHeight, ProductImageWidth } from '../../../constants/ProductConstants';
import { usePriceProps } from '../../../hooks/usePriceProps';
import { getPortraitImageSizeUrlByProductCode } from '../../../util/ImageUtil';
import { getProductDetailUrl } from '../../../util/ProductUtil';
export const AlternativeProductTile = ({ product, onWishListToggle, updateCompareList, }) => {
    var _a, _b;
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { root, isShopLanding, feature_toggles: { product_compare }, productImageConfig, } = useAemConfig();
    const selectedColor = findColor(product.colours, product.colourId);
    const productUrl = getProductDetailUrl(product, root);
    const compareCheckboxId = `product-compare-alternative-${product.productCode}-${product.colourId}`;
    const priceProps = usePriceProps({
        priceInformation: {
            prices: selectedColor.prices,
            hasDiscount: selectedColor.hasDiscount,
        },
    });
    const image = getPortraitImageSizeUrlByProductCode(product.productCode, selectedColor.image, productImageConfig.cdnDomains, ProductImageSizesPortraitEnum.basket);
    const handleWishListClick = () => onWishListToggle({
        productCode: product.productCode,
        productId: product.productId,
        colorId: selectedColor.colourId,
    });
    const handleCompareClick = () => updateCompareList({
        brand: product.brand,
        color: selectedColor.colourId,
        image: selectedColor.image,
        productCode: product.productCode,
        selected: false,
        id: product.productId,
        title: product.title,
        gender: product.genderCode,
        url: productUrl,
        colorDescription: selectedColor.description,
        collapsedComparePopup: true,
    });
    return (_jsxs(ProductTile, { variant: "horizontal", product: {
            image,
            alt: product.title,
            title: product.title,
            brand: product.brand,
            review: {
                amount: (_a = product.productReviews) !== null && _a !== void 0 ? _a : 0,
                score: (_b = product.productRating) !== null && _b !== void 0 ? _b : 0,
            },
        }, children: [_jsx(ProductTile.Area, { area: "primary", href: productUrl, children: _jsx(ProductTile.Image, { lazyLoad: true, width: ProductImageWidth.ALTERNATIVE_TILE, height: ProductImageHeight.ALTERNATIVE_TILE }) }), _jsx(ProductTile.Area, { area: "secondary", href: productUrl, containerOptions: { mobile: { spacing: { paddingLeft: 1.5 } } }, children: _jsxs(Stack, { direction: "col", gap: "2", children: [_jsx(ProductTile.Title, { brandOnTheSameLine: true, reserveLine: 2, lineClamp: 2, size: TextSize.MEDIUM, containerOptions: { mobile: { spacing: { marginRight: 3 } } } }), _jsx(ProductTile.Rating, {}), !!priceProps && _jsx(Price, Object.assign({}, priceProps)), _jsxs(TextAlpha, { variant: "bodyS", color: "subtle", children: [product.colours.length, " ", t('lister.swatch.counter', { count: product.colours.length })] }), product_compare && (_jsx(Checkbox, { id: compareCheckboxId, name: compareCheckboxId, value: compareCheckboxId, label: t('productCompare.pdp.checkbox'), checked: selectedColor.isCompareProduct || false, onChange: handleCompareClick }))] }) }), !isShopLanding && (_jsx(Overlay, { noPointerEvents: true, children: _jsx(Stack, { flex: { grow: 1 }, justify: "end", align: "start", children: _jsx(IconButton, { onClick: handleWishListClick, variant: "plain", theme: "branded", size: "sm", icon: {
                            source: selectedColor.inWishList ? HeartFillIcon : HeartIcon,
                            animation: selectedColor.inWishList ? 'pulse' : undefined,
                        } }) }) }))] }));
};
